export default __webpack_public_path__ + "static/media/arrow-right.2da4c4ca.svg";